export default __webpack_public_path__ + "atomic/_patterns/03-organisms/card-list/_card-list.twig";